export default "__VITE_ASSET__CXlHyOMb__"